module.exports = __webpack_public_path__ + "static/flags/NS-419070ea91daa028a7994222ff3e6bb7.gif";